import { render } from "./ProviderEdit.vue?vue&type=template&id=6bafbb34"
import script from "./ProviderEdit.vue?vue&type=script&lang=js"
export * from "./ProviderEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__